module.exports = __webpack_public_path__ + "static/img/clearing-new.1cb1adf.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/clearing-new.svg
// module id = o5Vm
// module chunks = 0